export const algoliaAutocomplete = {
  key: 'algoliaAutocomplete',
  name: 'Algolia Autocomplete',
  siteIdentifier: 'global',

  searchPlaceholder: 'Search',
  searchResults: 'Search results',
  inSubcategory: 'in {subcategory}',
  recentSearches: 'Recent Searches',
  popularSearches: 'Popular Searches',
  noResults: 'No Results',
  noResultsForQuery: 'No results for "{query}".',
  noResultsAdviceSpelling: 'Double-check your spelling',
  noResultsAdviceFewerWords: 'Use fewer keywords',
  noResultsAdviceLessSpecific: 'Search for a less specific item',
  featured: 'Featured',
  products: 'Products',
  learn: 'Learn',
  articles: 'Articles',
  blog: 'Blog',
  suggestions: 'Suggestions',
  viewAllProducts: 'View All Products ({total})',
  viewAllArticles: 'View All Articles ({total})',
  connectionError: 'Connection Error',
  connectionErrDesc:
    'We had trouble reaching the search servers. Please check your internet connection and try again.',

  // Screen announcer translations
  announcerRecentSearches: '{count} recent searches',
  announcerSuggestions: '{count} suggestions',
  announcerFeaturedItems: '{count} featured items',
  announcerProducts: '{count} products',
  announcerArticles: '{count} articles',
  announcerPopularSearches: '{count} popular searches',
  announcerAvailable: 'available',
  announcerAnd: 'and',
  announcerProduct: '{title}, price {price}',
  announcerProductSale: '{title}, price {price}, was {comparePrice}',
};
